import Splide from '@splidejs/splide'
import '@splidejs/splide/css'
import { addStaticSplideClasses, bp, connectSplideArrows, connectSplideBullets, connectSplideCarouselBullets, dev, mm, sel, selAll } from './utils'

gsap.registerPlugin(ScrollTrigger)

export default function Exec25() {
  console.log('Exec-25 loaded')
  const arrowsW = 'exec-arrows'
  const sliderOpts = {
    arrows: false,
    pagination: false,
    gap: '2.25rem',
    //   type: 'loop',
    rewind: true,
    speed: 3000,
    // interval: 1000,
    autoplay: dev ? false : true,
    easing: 'cubic-bezier(0.16, 1, 0.3, 1)',
    dragMinThreshold: {
      mouse: 50,
      touch: 50,
    },
  }
  function whyInit() {
    const prefix = 'exec-why'
    const slider$ = sel(`.${prefix}__slider`)
    slider$.classList.add('splide-overflow')
    addStaticSplideClasses(slider$)

    const slider = new Splide(slider$, {
      perPage: 1,
      ...sliderOpts,
      breakpoints: {
        768: {
          speed: 1000,
        },
      },
    }).mount()
    connectSplideArrows(slider, slider$.sel(`.${arrowsW}`))
    connectSplideBullets(slider, slider$.sel('.bullets'))
  }
  whyInit()

  function statsInit() {
    const prefix = 'exec-stats'
    const slider$ = sel(`.${prefix}__slider`)
    slider$.classList.add('splide-overflow')
    addStaticSplideClasses(slider$)

    const slider = new Splide(slider$, {
      fixedWidth: '25rem',
      ...sliderOpts,
      breakpoints: {
        768: {
          fixedWidth: false,
          speed: 1000,
        },
      },
    }).mount()
    connectSplideCarouselBullets(slider, slider$.sel('.bullets'))
    connectSplideArrows(slider, slider$.sel(`.${arrowsW}`))
    // connectSplideBullets(slider, slider$.sel('.bullets'))
  }
  statsInit()

  function propsInit() {
    const prefix = 'exec-props'
    const slider$ = sel(`.${prefix}__slider`)
    slider$.classList.add('splide-overflow')
    addStaticSplideClasses(slider$)

    const slider = new Splide(slider$, {
      perPage: 2,
      ...sliderOpts,
      breakpoints: {
        768: {
          perPage: 1,
          speed: 1000,
        },
      },
    }).mount()
    connectSplideCarouselBullets(slider, slider$.sel('.bullets'))
    connectSplideArrows(slider, slider$.sel(`.${arrowsW}`))
    // connectSplideBullets(slider, slider$.sel('.bullets'))
  }
  propsInit()

  // PROP CARDS
  mm.add(bp.tabUp, () => {
    const cardList$ = sel('.promise__list')
    const card$a = selAll('.promise__item')

    if (cardList$ && card$a.length > 0) {
      // Initial styles
      gsap.set(card$a, {
        scale: 0.75,
        transformOrigin: 'center center',
        marginBottom: '-1.5rem',
        backgroundColor: '#051C26',
      })
      gsap.set(cardList$, { gap: 0 })

      // Config
      const SCALE_MIN = 0.75
      const SCALE_MAX = 1
      const MAX_Z = 1000

      ScrollTrigger.create({
        trigger: cardList$,
        start: 'top bottom',
        end: 'bottom top',
        scrub: 2, // immediate catch-up, no smoothing

        onUpdate(self) {
          const viewportCenter = window.innerHeight / 2

          card$a.forEach((card, i) => {
            const rect = card.getBoundingClientRect()
            const cardCenter = rect.top + rect.height / 2

            // Distance from viewport center in px
            const dist = Math.abs(viewportCenter - cardCenter)

            // "Far" distance at which we clamp min scale
            const maxDist = viewportCenter + rect.height / 2

            // Normalize 0 (center) -> 1 (far)
            let t = dist / maxDist
            if (t > 1) t = 1

            // Scale: 1 at center, down to 0.75
            const scale = SCALE_MAX - (SCALE_MAX - SCALE_MIN) * t

            // z-index: highest at center, lower as it goes away
            const zIndex = Math.round(MAX_Z - t * (MAX_Z - 1))

            gsap.set(card, { scale, zIndex })
          })
        },
      })
    }
  })
}
